import { WorkOrderStatus } from '@features/siteStatusV2/constants/report';

const MapWorkOrderStatusToDisplay: Record<WorkOrderStatus, string> = {
  [WorkOrderStatus.CANCELLED]: 'report.workOrderStatus.cancelled',
  [WorkOrderStatus.CREATED]: 'report.workOrderStatus.created',
  [WorkOrderStatus.STARTED]: 'report.workOrderStatus.started',
  [WorkOrderStatus.IN_PROGRESS]: 'report.workOrderStatus.inProgress',
  [WorkOrderStatus.TO_BE_SCHEDULED]: 'report.workOrderStatus.toBeScheduled',
  [WorkOrderStatus.TO_BE_CONSIDERED]: 'report.workOrderStatus.toBeConsidered',
  [WorkOrderStatus.COMPLETED]: 'report.workOrderStatus.completed',
  [WorkOrderStatus.SUSPENDED]: 'report.workOrderStatus.suspended',
  [WorkOrderStatus.SCHEDULED]: 'report.workOrderStatus.scheduled',
  [WorkOrderStatus.FINISHED]: 'report.workOrderStatus.finished',
  [WorkOrderStatus.VALIDATED]: 'report.workOrderStatus.validated',
  [WorkOrderStatus.NO_STATUS]: '-'
};

export default MapWorkOrderStatusToDisplay;
